import client from './client';

/**
 * POST /login
 * Returns the `data` block: { token, id, email, username, first_name, ... }
 */
export function login(email, password) {
  return client
    .post('/login', { email: email, password: password })
    .then(function (response) {
      return response.data && response.data.data;
    });
}

/**
 * GET /passport-data  (auth:app_api)
 * Returns the flat profile object including points and stamps.
 */
export function fetchPassportData() {
  return client.get('/passport-data').then(function (response) {
    return response.data;
  });
}

/**
 * POST /delete-account  (auth:app_api)
 * The API answers 200 with { success: false } when deletion fails, so the
 * success flag has to be checked explicitly rather than relying on status.
 */
export function deleteAccount() {
  return client.post('/delete-account', {}).then(function (response) {
    const data = response.data || {};
    if (!data.success) {
      throw new Error(data.message || 'Unable to delete account.');
    }
    return data;
  });
}
